// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard, Heart, Users, Sparkles, BookOpen,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { ROUTES, DOSSIER_OVERVIEW } from '@/lib/constants/routes'

const tabs = [
  { label: 'Dashboard', path: ROUTES.DASHBOARD,      icon: LayoutDashboard, end: true },
  { label: 'Wensen',    path: ROUTES.WISHES,          icon: Heart,           end: false },
  { label: 'Dossiers',  path: DOSSIER_OVERVIEW,        icon: BookOpen,        end: false },
  { label: 'Netwerk',   path: ROUTES.TRUSTED_PERSON,  icon: Users,           end: false },
  { label: 'Hulp',      path: ROUTES.AI_GUIDE,        icon: Sparkles,        end: false },
]

export function BottomTabBar() {
  return (
    <nav
      className="flex items-stretch border-t border-sand-200 bg-white/95 backdrop-blur-sm"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)', minHeight: '68px' }}
      aria-label="Hoofdnavigatie"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon
        return (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center justify-center gap-1 pt-2 pb-3',
                'transition-colors duration-150',
                isActive ? 'text-sage-600' : 'text-ink-4',
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={cn('h-5 w-5', isActive && 'stroke-[2.5]')} />
                <span className={cn(
                  'text-[10px] leading-none',
                  isActive ? 'font-semibold' : 'font-normal',
                )}>
                  {tab.label}
                </span>
              </>
            )}
          </NavLink>
        )
      })}
    </nav>
  )
}
